export const SET_PANEL = 'SET_PANEL';
export const SET_MODULE = 'SET_MODULE';
export const SET_LOADING_MAP = 'SET_LOADING_MAP';
export const SET_ACTION_MAP = 'SET_ACTION_MAP';
export const SET_CONFIG_MAP = 'SET_CONFIG_MAP';
